import React from "react";
import { NewEmployeeVestingReportContainer } from "../../../containers";

const NewEmployeeVestingReport = (props) => {
  return <NewEmployeeVestingReportContainer {...props} />;
};

export default NewEmployeeVestingReport;
